module.exports = __webpack_public_path__ + "3da55c66c7d759079ff40e6796c1d131.svg";